import { render, staticRenderFns } from "./deleteHousekeepingType.vue?vue&type=template&id=5c47908a&scoped=true"
import script from "./deleteHousekeepingType.vue?vue&type=script&lang=js"
export * from "./deleteHousekeepingType.vue?vue&type=script&lang=js"
import style0 from "./deleteHousekeepingType.vue?vue&type=style&index=0&id=5c47908a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c47908a",
  null
  
)

export default component.exports